import React from "react";
import ForecastModalTopo from "./forecastModalTopo";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
import ForecastModalGrid from "./forecastModalGrid";
import Forecast from "../../components/classes/Forecast";
import { useTranslation } from "react-i18next";

export default function ForecastModal(props: ForecastModalPropsTypes) {
  const { t } = useTranslation();

  return (
    <>
      <div className="containerForecastModal">
        <div className="containerTitleModal">
          <ForecastModalTopo />
        </div>
        <div className="containerToolbarModal">
          <Tooltip title={t("pages.monthlyForecast.text.exitModal")}>
            <IconButton onClick={props.handleClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal">
          <ForecastModalGrid forecasts={props.forecasts} />
        </div>
      </div>
    </>
  );
}

interface ForecastModalPropsTypes {
  handleClose?: any;
  forecasts?: Forecast[];
}
